export default "__VITE_ASSET__Dx99MS3Z__"